/**
 * @generated SignedSource<<e35666b3cf185e7ddd439af07dd6fc1e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AssemblyItemsListGroup_ProductSkuAssemblyItemComposition$data = {
  readonly minQuantity: number;
  readonly maxQuantity: number;
  readonly items: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly sku: {
          readonly sellers: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly _id: string;
              };
            }>;
          };
        };
        readonly " $fragmentSpreads": FragmentRefs<"AssemblyItemSelect_ProductSkuAssemblyItemCompositionItem">;
      };
    }>;
  };
  readonly " $fragmentType": "AssemblyItemsListGroup_ProductSkuAssemblyItemComposition";
};
export type AssemblyItemsListGroup_ProductSkuAssemblyItemComposition$key = {
  readonly " $data"?: AssemblyItemsListGroup_ProductSkuAssemblyItemComposition$data;
  readonly " $fragmentSpreads": FragmentRefs<"AssemblyItemsListGroup_ProductSkuAssemblyItemComposition">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AssemblyItemsListGroup_ProductSkuAssemblyItemComposition",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "minQuantity",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "maxQuantity",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductSkuAssemblyItemCompositionItemConnection",
      "kind": "LinkedField",
      "name": "items",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProductSkuAssemblyItemCompositionItemEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProductSkuAssemblyItemCompositionItem",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ProductSku",
                  "kind": "LinkedField",
                  "name": "sku",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ProductSkuSellerConnection",
                      "kind": "LinkedField",
                      "name": "sellers",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "ProductSkuSellerEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Seller",
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "_id",
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "AssemblyItemSelect_ProductSkuAssemblyItemCompositionItem"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProductSkuAssemblyItemComposition",
  "abstractKey": null
};

(node as any).hash = "52071766bba0dc270e11670208eb58a3";

export default node;
